import { render, staticRenderFns } from "./Colony.vue?vue&type=template&id=02a869f7&scoped=true&"
import script from "./Colony.vue?vue&type=script&lang=js&"
export * from "./Colony.vue?vue&type=script&lang=js&"
import style0 from "./Colony.vue?vue&type=style&index=0&id=02a869f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a869f7",
  null
  
)

export default component.exports